import React, { useEffect, useState, useRef, useContext, useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { Container, Box, TextField } from '@mui/material';
import { Typography } from '@mui/material';

import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow} from '@mui/material';

import { AppContext } from '/@/app/AppContext';
import { useApi} from '/@/app/Api';


export const RecordsView = () =>
{

const api=useApi();
const { t,i18n } = useTranslation();
const [rows, setRows] = useState([]);
const statusRowRef = useRef(null);
const [tableStatus, setTableStatus] = useState('');
const [dataStatus, setDataStatus] = useState('');
const [dataView,setDataView]=useState({filter:'',size:null});
const dataInfo=useRef({total:null,retrieved:null,fetching:null});

const [showFilter, setShowFilter] = useState(true);

const { mainViewportRef} = useContext(AppContext);

const lastPos = useRef(1);

const fetchData = useCallback(function(startNew=null)
{
	const mainViewport=mainViewportRef.current;
	const statusRow=statusRowRef.current;

	const statusRowY=statusRow.getBoundingClientRect().top;
	const pageSize=Math.ceil(mainViewport.clientHeight/statusRow.clientHeight)+1;

	if (startNew)
	{
		dataInfo.current={total:null,retrieved:null,fetching:null};
		setDataView({filter:startNew.filter, size:pageSize});
		return;
	};
	//if (statusRowY<mainViewport.clientHeight*1.5 && dataView.size<=dataInfo.current.retrieved)
	if (statusRowY<mainViewport.clientHeight*1.5)
	{
		const newSize=(dataInfo.current.retrieved??0)+pageSize;

		setDataView((prev)=>({...prev,size:newSize}));
	};

});

useEffect(() =>
{
	let scrollDebounce=null;
	let lastPos = 0;
	const mainViewport=mainViewportRef.current;
	const handleScroll = () => {
		var pos=mainViewport.scrollTop;
		var scrollingUp=pos<lastPos;
		if (scrollDebounce) clearTimeout(scrollDebounce);
		scrollDebounce = setTimeout(() =>
		{
			pos=mainViewport.scrollTop;
			scrollingUp=(pos<lastPos) || pos==0;
			setShowFilter(scrollingUp)
			lastPos=pos;
		},scrollingUp?200:0);
		fetchData();
	};
	mainViewport.addEventListener('scroll', handleScroll);
	return () => mainViewport.removeEventListener('scroll', handleScroll);
}, [dataView]);

useEffect( () =>
{

	if (dataInfo.current.fetching) return;
	if ((dataInfo.current.retrieved??0)>=(dataView.size??0)) return;
	if ((dataInfo.current.retrieved??-1)>=(dataInfo.current.total??0)) return;
	setTableStatus(t('загрузка')+'...');
	dataInfo.current.fetching=dataView.size-(dataInfo.current.retrieved??0);
	api.request( `/api/v2/records/user_data`,{sre:dataView.filter,offset:dataInfo.current.retrieved,limit:dataInfo.current.fetching,lang:i18n.resolvedLanguage }, { method:'POST'})
	.then(data => {
		if (!Array.isArray(data) && 'error' in data)
		{
			dataInfo.current={total:null,retrieved:null,fetching:null};
			setDataStatus(t(data.error));
			setTableStatus('\xa0');
			return;
		};

		const chunk=data.map(p=>({id:p.id,parameter:p.parameter,'unit-expr':p['unit-expr'],value:p.value,variant:p.variant,date:p.date}));
		if (dataInfo.current.retrieved)
			setRows((prev) => [...prev, ...chunk]);
		else
			setRows((prev) => chunk);
		const totalRows=data.length?data[0]['count']:dataInfo.current.retrieved;
		const rowsRetieved=(dataInfo.current.retrieved??0)+data.length;

		dataInfo.current={total:totalRows,retrieved:rowsRetieved,fetching:null};
		setDataStatus(totalRows?''+totalRows+' '+t('найдено'):t('ничего не найдено') );
		setTableStatus(rowsRetieved?''+rowsRetieved+' '+t('показано'):'');
	})
	.catch(error => { dataInfo.fetching=null;console.log(data); });
},[dataView]);


const filterDebounce=useRef(null);

const handleFilter = useCallback((event) =>
{
	const value=event?event.target.value:'';
	if (filterDebounce.current) clearTimeout(filterDebounce.current);
	filterDebounce.current = setTimeout(() => {
		fetchData({filter:value});
	}, 1000);
});

useEffect(() =>
{
	fetchData({filter:''});
},[]);

return (
<>

<Box
	sx={{
		position: 'sticky',
		top:  0,
		pb:1,
		zIndex: 1000,
		backgroundColor: 'white',
		transition: 'transform 0.05s ease-in-out',
		transform: showFilter ? 'translateY(0)' : 'translateY(-100%)',
		'&::before': {
			content: '""',
			position: 'absolute',
			top: '-30px',
			left: 0,
			right: 0,
			height: '30px',
			backgroundColor: 'white',
		}

	}}
	style={{visibility:showFilter?'visible':'hidden'}}
>
	<TextField
		fullWidth
		onChange={handleFilter}
		placeholder={t("Введите параметр")}
		inputProps={{ autoComplete: 'off' }}
	/>
	<Typography variant="body2" color="text.disabled" sx={{ml:2}}>{dataStatus}</Typography>
</Box>

<TableContainer>
<Table>
    <TableBody>
	{rows.map((row) => (
	    <TableRow key={row.id}>
		<TableCell>{row['parameter']}</TableCell>
		{row['variant'] && row['variant'].length>3?
			(<TableCell ><span>{row['variant']}</span> {row['unit-expr']}<Box sx={{fontSize:'0.8em',color:"text.disabled" }}>{row['date']?.substring(0,10)}</Box></TableCell>)
			:(<TableCell style={{ whiteSpace: 'nowrap' }}><span style={{fontSize:'1.5em'}}>{row['variant']||row['value']}</span> {row['unit-expr']}<Box sx={{fontSize:'0.8em',color:"text.disabled" }}>{row['date']?.substring(0,10)}</Box></TableCell>)
		}
	    </TableRow>
	))}
	<TableRow ref={statusRowRef} key='status-row' >
		<TableCell sx={{borderBottom:'none'}}><Typography variant="body2" color="text.disabled">{tableStatus}&nbsp;</Typography></TableCell>
	</TableRow>
    </TableBody>
</Table>
</TableContainer>

</>
);
} // RecordsView
